<template>
  <div class="pb-6 pt-2">
  <div class="flex justify-between w-full items-baseline border-t-4 border-gray-light pt-2" v-if="heading">
    <div class="text-black font-bold pt-4 text-base">{{heading}}</div>
  </div>
  <div class="flex justify-end text-black border-b border-gray-light">
    <div class="flex w-3/4">
      <div class="w-1/3 flex flex-col items-end pb-2">
        <div class="text-xs">In</div>
      </div>
      <div class="w-1/3 flex flex-col items-end pb-2">
        <div class="text-xs">Out</div>
      </div>
      <div class="w-1/3 flex flex-col items-end pb-2">
        <div class="text-xs">Net</div>
      </div>
    </div>
  </div>

  <div v-for="i in items" class="flex font-mono border-b border-dotted border-gray-lighter py-2">
    <div class="font-bol text-lg w-1/4">
      <div class="font-bold text-xs">
        <div @click="$emit('select', i)"
          :class="{
                     'underline cursor-pointer text-full-blue font-normal': isLinked
                     }" v-html="parsedSymbol(i.label)" />
      </div>
    </div>
    <div class="flex w-3/4">
      <div class="w-1/3 flex flex-col items-end">
        <div
          class="font-bold text-sm"
          :class="{
                 'text-light-red': i.i < 0,
                 'text-dark-green': i.i > 0,
                 'text-black': i.i === 0
                 }">{{i.i}}</div>
      </div>
      <div class="w-1/3 flex flex-col items-end">
        <div
          class="font-bold text-sm"
          :class="{
                 'text-light-red': i.o < 0,
                 'text-dark-green': i.o > 0,
                 'text-black': i.o === 0
                 }">{{i.o}}</div>
      </div>
      <div class="w-1/3 flex flex-col items-end">
        <div
          class="font-bold text-sm"
          :class="{
            'text-light-red': i.net < 0,
            'text-dark-green': i.net > 0,
            'text-black': i.net === 0
          }"
        >{{i.net}}</div>
      </div>
    </div>
  </div>
  </div>
</template>


<script>
 export default {
   props: {
     heading: {
       type: String
     },
     items: {
       type: Array,
       required: true
     },
     isLinked: {
       type: Boolean
     }
   },
   methods: {
     parsedSymbol (sym) {
       return twemoji.parse(sym)
     }
   }
 }
</script>
